<template>
  <div class="classification" ref="container">
    <div class="clearfix">
      <div class="left-box">
        <div class="answer-group">
          <div class="classification-box px-4 pt-2" ref="group">
            <div class="leading-base text-center">
              <span>选项区</span>
            </div>
            <vuedraggable :group="question.id" v-model="issue.rows">
              <transition-group tag="ul" class="mt-3 px-1 pb-5" style="min-height: 150px">
                <li v-for="item in issue.rows" :key="item.row_id" class="classification-item">
                  <div v-html="item.content.richText"></div>
                </li>
              </transition-group>
            </vuedraggable>
            <div class="operate-btn">
              <div class="operate-btn">
                <div class="arrow-up" @click="onScrollUp('group')">
                  <div class="arrow--inner"></div>
                </div>
                <div class="arrow-down" @click="onScrollDown('group')">
                  <div class="arrow--inner"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-box">
        <div class="classification-group">
          <div class="classification-box px-2" ref="classification">
            <div class="text-center py-1">
              <span>分类区</span>
            </div>
            <ul>
              <li v-for="item in issue.items" :key="item.id" class="bg-white border border-eee border-solid rounded-small mb-2">
                <div class="classification-title text-center py-2 leading-base">
                  <div v-html="item.content.richText"></div>
                </div>
                <vuedraggable :group="question.id" v-model="item.selects">
                  <transition-group tag="div" class="mt-3 px-2 pb-5">
                    <div v-for="item in item.selects" :key="item.row_id" class="classification-item">
                      <div v-html="item.content.richText"></div>
                    </div>
                    <div v-if="!item.selects.length" class="classification-empty" key="category-empty">
                      <span>拖入此处</span>
                    </div>
                  </transition-group>
                </vuedraggable>
              </li>
            </ul>
            <div class="operate-btn">
              <div class="arrow-up" @click="onScrollUp('classification')">
                <div class="arrow--inner"></div>
              </div>
              <div class="arrow-down" @click="onScrollDown('classification')">
                <div class="arrow--inner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { previewImage } from '@/assets/js/preview-image'
import Vuedraggable from 'vuedraggable'

export default {
  name: 'Classification',
  changeExpr: 'changeExpr',
  components: { Vuedraggable },
  data() {
    return {
      popup: false,
      currentItem: null,
      columns: []
    }
  },
  computed: {
    changeExpr() {
      let items = this.issue.items
      return items
        .map(item => {
          return item.selects.map(i => i.row_id).join(',')
        })
        .join('-')
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.columns = this.issue.items.map(item => {
        return {
          text: item.content.text,
          id: item.id
        }
      })
    },
    onScrollUp(ref) {
      const el = this.$refs[ref]
      el.scrollTop -= 20
    },
    onScrollDown(ref) {
      const el = this.$refs[ref]
      el.scrollTop += 20
    }
  },
  watch: {
    changeExpr() {
      this.$nextTick(() => {
        if (this.$refs.container) {
          previewImage(this.$refs.container)
        }
      })
    }
  }
}
</script>
